import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useGlobalStore = defineStore('global', () => {
    const pageTitle = ref('');
    const isConnectionError = ref(false);
    const isLoading = ref(false);

    watch(pageTitle, () => {
        document.title = pageTitle.value ? `${pageTitle.value} - 't Web Incontrol` : 't Web Incontrol';
    });

    return { pageTitle, isConnectionError, isLoading };
});
